import { render, staticRenderFns } from "./StampTaxDone.vue?vue&type=template&id=319a0139&scoped=true&"
import script from "./StampTaxDone.vue?vue&type=script&lang=js&"
export * from "./StampTaxDone.vue?vue&type=script&lang=js&"
import style0 from "./StampTaxDone.vue?vue&type=style&index=0&id=319a0139&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a0139",
  null
  
)

export default component.exports